import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ExistsTransformation } from 'app/model/dataflow/existstransformation';
import { BaseMultiInputStreamTransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-multi-input-stream-transformation.adapter';
import { DataFlowExpressionUtils } from '../expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ExistsTransformation),
    asynchronous: true
})
export class ExistsTransformationAdapter extends BaseMultiInputStreamTransformationAdapter {
    protected getExpressionScript(transformation: ExistsTransformation): string {
        let expressionScript = transformation.useCustomExpression
            ? DataFlowExpressionUtils.wrapExpressionWithEmptyValue(transformation.customExpression.expression)
            : super.getExpressionScript(transformation);
        expressionScript += `${expressionScript ? ',\n\t' : ''}negate:${transformation.negate}`;
        return expressionScript;
    }
}
